import { FC, ReactElement, useMemo, useState, Children, cloneElement } from 'react';
import Buttons from '@components/Buttons';
import ArrowCircleLeft from '@components/Icons/ArrowCircleLeft';
import s from './CartCheckoutForm.module.scss';

const CartCheckoutForm: FC = ({ children }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const childArray = useMemo(() => Children.toArray(children), [children]);
  const goToNextStep = (): void => {
    if (currentStep !== childArray.length - 1) {
      setCurrentStep(prev => prev + 1);
      window.scrollTo({ top: 0 });
    }
  };
  const goToPreviousStep = (): void => {
    if (currentStep !== 0) {
      setCurrentStep(prev => prev - 1);
      window.scrollTo({ top: 0 });
    }
  };
  const goToFirstStep = (): void => {
    if (currentStep !== 0) {
      setCurrentStep(0);
      window.scrollTo({ top: 0 });
    }
  };

  if (!childArray[currentStep]) {
    return null;
  }
  return (
    <>
      {currentStep !== 0 && (
        <div className={s.backButton}>
          <Buttons isWrapper onClick={goToPreviousStep}><ArrowCircleLeft size={16} weight='fill' /> Back</Buttons>
        </div>
      )}
      {cloneElement(childArray[currentStep] as ReactElement, {
        goToNextStep,
        goToPreviousStep,
        onChangeBookingTime: () => {
          (childArray[currentStep] as ReactElement)?.props?.onChangeBookingTime?.();
          goToFirstStep();
        },
        onFinish: () => {
          (childArray[currentStep] as ReactElement)?.props?.onFinish?.();
          goToNextStep();
        },
      })}
    </>
  );
};

export default CartCheckoutForm;
